import { api } from './api';

export const creditsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCredits: builder.query({
      query: (params = {}) => ({
        url: '/admin/credits',
        params: {
          page: params.page ?? 1,
          limit: params.limit ?? 10,
          ...(params.search && { search: params.search }),
          ...(params.credit_level && { credit_level: params.credit_level }),
          ...(params.model_id && { model_id: params.model_id }),
        },
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ id }) => ({ type: 'ModelCredit', id })),
              { type: 'ModelCredit', id: 'LIST' },
            ]
          : [{ type: 'ModelCredit', id: 'LIST' }],
    }),
    getCredit: builder.query({
      query: (id) => ({ url: `/admin/credits/${id}` }),
      providesTags: (result, error, id) => [{ type: 'ModelCredit', id }],
    }),
    getCreditsModels: builder.query({
      query: () => ({ url: '/admin/credits/models' }),
      providesTags: [{ type: 'ModelCredit', id: 'MODELS' }],
    }),
    getCreditsSchemas: builder.query({
      query: ({ modelId, field_name }) => ({
        url: `/admin/credits/models/${modelId}/schemas`,
        params: field_name ? { field_name } : undefined,
      }),
      providesTags: (result, error, { modelId }) => [
        { type: 'ModelCredit', id: `SCHEMAS-${modelId}` },
      ],
    }),
    getCreditsSchemaOptions: builder.query({
      query: (schemaId) => ({
        url: `/admin/credits/schemas/${schemaId}/options`,
      }),
      providesTags: (result, error, schemaId) => [
        { type: 'ModelCredit', id: `OPTIONS-${schemaId}` },
      ],
    }),
    createCredit: builder.mutation({
      query: (body) => ({
        url: '/admin/credits',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'ModelCredit', id: 'LIST' }],
    }),
    updateCredit: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/admin/credits/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'ModelCredit', id },
        { type: 'ModelCredit', id: 'LIST' },
      ],
    }),
    deleteCredit: builder.mutation({
      query: (id) => ({
        url: `/admin/credits/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'ModelCredit', id },
        { type: 'ModelCredit', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useGetCreditsQuery,
  useGetCreditQuery,
  useGetCreditsModelsQuery,
  useGetCreditsSchemasQuery,
  useGetCreditsSchemaOptionsQuery,
  useCreateCreditMutation,
  useUpdateCreditMutation,
  useDeleteCreditMutation,
} = creditsApi;
